import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import {
    AddCategoryModal,
    Categories,
    CategoryHeader,
} from '../components/InfoHub';

const InfoHubCategory = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showEdit, setShowEdit] = useState(false);
    const [categories, setCategories] = useState([]);

    const [addCategoryModal, setOpenAddCategoryModal] = useState(false);
    const handleAddCategoryModal = () =>
        setOpenAddCategoryModal(!addCategoryModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Info Hub') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            const editPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes('Info Hub') &&
                        item.permissionType.includes('edit'))
            );

            if (editPermit) {
                setShowEdit(true);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getCategories = async () => {
            const categoryFromServer = await fetchCategories();
            setCategories(categoryFromServer);
        };

        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch Category
    const fetchCategories = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/infohub/getcategory'
        );
        const data = await res.json();

        return data.FileList;
    };

    // Add Category
    const addCategory = async (category) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/addcategory';
        const categoryDetails = {
            categoryName: category.categoryName,
            categoryDesc: category.categoryDesc,
            createdBy: category.createdBy,
        };
        axios
            .post(url, categoryDetails)
            .then(
                (response) => alert('Folder has been successfully created!'),
                setTimeout(() => {
                    setOpenAddCategoryModal(!addCategoryModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    // Delete Category
    const deleteCategory = (categoryList) => {
        const category = categoryList.category;
        const requests = [];
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/deletecategory';

        for (let i = 0; i < category.length; i++) {
            requests.push(
                axios.post(url, {
                    categoryID: category[i].categoryID,
                    deletedBy: category[i].deletedBy,
                })
            );
        }

        axios
            .all(requests)
            .then(
                axios.spread((...responses) => {
                    alert('Folder has been successfully deleted!');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                })
            )
            .catch((err) => {
                console.error(err);
            });
    };

    const CategoryList = () => {
        return (
            <>
                {categories.length > 0 ? (
                    <Categories
                        categories={categories}
                        onDelete={deleteCategory}
                        showEdit={showEdit}
                    />
                ) : (
                    <div style={{ marginTop: '20px', marginLeft: '10px' }}>
                        No folders to show
                    </div>
                )}
            </>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <CategoryHeader />
                        <div className='table-wrapper'>
                            {showEdit && (
                                <Fragment>
                                    <Button onClick={handleAddCategoryModal}>
                                        Create New Folder
                                    </Button>
                                    <AddCategoryModal
                                        show={addCategoryModal}
                                        handleClose={handleAddCategoryModal}
                                        onAdd={addCategory}
                                    />
                                </Fragment>
                            )}
                            <CategoryList />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default InfoHubCategory;
